
function Philosophy(props)
{
  return(
    <div id="philosophy">
      <div id="body-title">
        {"Artistic Philosophy"}
      </div>
      <div id="body-text">
Traditional Minhwa is often perceived as ancient artwork disconnected from modern times. However, the symbolic motifs, expressive methods, and adaptive applications of Minhwa share many similarities with contemporary design practices. Historically, Minhwa was not merely decorative but often adapted and restructured to suit specific needs, whether for adorning spaces or objects.
      </div>
      <div id="body-text">
What fascinates me is how Minhwa was created by a diverse range of artists—from professionally trained court painters to self-taught artisans. Many unsigned works, while seemingly naïve or unpolished, reveal boundless creativity and freedom of expression, making them uniquely compelling.
      </div>
      <div id="body-text">
My goal is to bring these timeless qualities into the present. By blending traditional symbolism and design elements with modern techniques, I seek to create a new artistic language that connects past and present.
      </div>
      <div id="body-text">
Note: When referencing traditional cultural sources for my research on themes and design elements, I include proper citations in the descriptions of my work.
      </div>
    </div>
  );
}
export default Philosophy;
